import { render } from "./BaseDot.vue?vue&type=template&id=726f0a49"
import script from "./BaseDot.vue?vue&type=script&lang=js"
export * from "./BaseDot.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__